module.exports = __webpack_public_path__ + "img/vertical-three-dots-icon-25022022.b2663948.svg";